<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="title-heading d-flex justify-content-between">
          <h1>{{ $static('catalog.title', 'Каталог товарів') }}</h1>
          <div class="view-mode">
            <Popper arrow :content="$static('catalog.wg', 'Сітка')" hover placement="top" style="white-space: nowrap">
              <a href="javascript:void(0)" :class="{active: !isList}" @click="isList=false">
                <span class="icon icon-layout"></span>
              </a>
            </Popper>
            <Popper arrow :content="$static('catalog.wl', 'Список')" hover placement="top" style="white-space: nowrap">
              <a href="javascript:void(0)" :class="{active: isList}" @click="isList=true">
                <span class="icon icon-rows"></span>
              </a>
            </Popper>
          </div>
        </div>
        <div class="toolbar-panel" >
          <div class="left-toolbar">
<!--             open filter trigger-->
<!--                        <a href="javascript:void(0);" class="filter_trigger" @click="openFilter">-->
<!--                          <span class="text">Фильтры</span>-->
<!--                          <span class="icon icon-filter"></span>-->
<!--                        </a>-->
<!--            end open filter trigger-->
          </div>
        </div>

        <div class="large-button-panel catalog-large-button-panel">
          <div class="sorting-panel d-flex w-40">
            <div class="category-in w-50">
              <div class="form-group d-flex">
                <label class="category_in_label filter-label">{{ $static('catalog.t1', 'Категорія:') }}</label>
                <div class="selector-holder ">
                  <v-select id="editor_category" :searchable="false" :options="categoriesList" :reduce="c => c.code"
                            v-model="categoryFilter">
                    <template #open-indicator="{ attributes }">
                        <span v-bind="attributes">
                          <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                               xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M15.1528 8.22224C15.4213 8.49072 15.4213 8.92602 15.1528 9.19451L11.4861 12.8612C11.2177 13.1297 10.7824 13.1297 10.5139 12.8612L6.84721 9.19451C6.57872 8.92602 6.57872 8.49072 6.84721 8.22224C7.11569 7.95375 7.55099 7.95375 7.81948 8.22224L11 11.4028L14.1805 8.22224C14.449 7.95375 14.8843 7.95375 15.1528 8.22224Z"
                                  fill="#212121"/>
                          </svg>
                        </span>
                    </template>
                  </v-select>

                  <!--                    <select id="input_category_in" class="select-custom selectpicker category_in_select" v-model="categoryFilter">-->
                  <!--                      <option selected="selected" value="">Все</option>-->
                  <!--                      <template v-if="categories">-->
                  <!--                        <option v-for="(c,idx) in categories.list" :value="c.name">{{c.name}}</option>-->
                  <!--                      </template>-->
                  <!--                    </select>-->
                </div>
              </div>
            </div>
            <div class="sort-by w-50">
              <div class="form-group d-flex">
                <label class="sort-by_label filter-label">{{ $static('catalog.t2', 'Сортувати:') }}</label>
                <div class="selector-holder ">
                  <v-select id="input_sort" :searchable="false" :options="sortOptions" :reduce="c => c.value" v-model="sortBy">
                    <template #open-indicator="{ attributes }">
                        <span v-bind="attributes">
                          <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                               xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M15.1528 8.22224C15.4213 8.49072 15.4213 8.92602 15.1528 9.19451L11.4861 12.8612C11.2177 13.1297 10.7824 13.1297 10.5139 12.8612L6.84721 9.19451C6.57872 8.92602 6.57872 8.49072 6.84721 8.22224C7.11569 7.95375 7.55099 7.95375 7.81948 8.22224L11 11.4028L14.1805 8.22224C14.449 7.95375 14.8843 7.95375 15.1528 8.22224Z"
                                  fill="#212121"/>
                          </svg>
                        </span>
                    </template>
                  </v-select>
                  <!--                    <select id="input_sort" class="select-custom selectpicker sort-by_select" v-model="sortBy">-->
                  <!--                      <option selected="selected" value="">По умолчанию</option>-->
                  <!--                      <option value="-p">Цена (от дешевых к дорогим)</option>-->
                  <!--                      <option value="+p">Цена (от дорогих к дешевым)</option>-->
                  <!--                      <option value="priority">Популярные</option>-->
                  <!--                      <option value="time">Новинки</option>-->
                  <!--                    </select>-->
                </div>
              </div>
            </div>
          </div>

          <div class="search-panel w-40">
            <!--search panel-->
            <div class="search-group">
              <input type="text" name="input_search_catalog" class="input-search form-control custom-input" v-model="filter.search"
                     @keydown.enter="getItems"
                     :placeholder="$static('catalog.search', 'Пошук за Назвою/Описом/Артикулом')">
              <button class="search-btn" @click="getItems">
                <span class="icon icon-search"></span>
              </button>
            </div>
            <!-- end search panel-->
          </div>
<!--          <input type="file" name="import" style="display: none" id="file_import" @change="onImportFile" accept="text/csv">-->
<!--          -->
<!--          <label for="file_import" class="files-uploader"-->
<!--                 @drop.prevent="onImportDrop" @dragover.prevent="" @dragenter.prevent="" @dragleave.prevent="">-->
<!--            <div class="files-uploader-holder" v-if="!importFile">-->
<!--              <span>{{ $static('catalog.import', 'Імпорт csv') }}</span>-->
<!--            </div>-->
<!--            <template v-else>-->
<!--              <div class="files-uploader-holder">-->
<!--                <span>{{ importFile.name }}</span>-->
<!--              </div>-->
<!--              <Popper arrow :content="$static('catalog.upload', 'Завантажити файл CSV')" hover placement="top" style="white-space: nowrap">-->
<!--                <button class="btn-icon  btn-rounded btn-green" @click.prevent.stop="sendImport" style="margin-left:15px">-->
<!--                  <span class="icon icon-3upload"></span>-->
<!--                </button>-->
<!--              </Popper>-->
<!--            </template>-->
<!--          </label>-->
<!--          <div class="btn-download-holder">-->
<!--            <Popper arrow :content="$static('catalog.download', 'Скачати файл CSV')" hover placement="top" style="white-space: nowrap">-->
<!--              <button class=" btn-icon  btn-rounded" @click="exportCSV">-->
<!--                <span class="icon icon-download"></span>-->
<!--              </button>-->
<!--            </Popper>-->
<!--          </div>-->

          <button class=" default-btn btn-with-icon btn-accent" @click="addNew">
            <span class="text">{{ $static('catalog.add', 'Додати товар') }}</span>
            <span class="icon icon-add"></span>
          </button>
        </div>
        <div :class="{'products-grid': !isList, 'products-list': isList}">
          <div class="card_layout_top" v-if="isList">
            <div class="name name-product">{{ $static('catalog.t1', 'Категорія:') }}</div>
            <div class="name name-price">{{ $static('catalog.t2', 'Сортувати:') }}</div>
            <div class="name name-old-price">{{ $static('catalog.t3', 'Стара ціна') }}</div>
            <div class="name name-category">{{ $static('catalog.t4', 'Категорія') }}</div>
            <div class="name name-available">{{ $static('catalog.t5', 'Статус') }}</div>
            <div class="name name-check-available">{{ $static('catalog.t6', 'Доступність продукту') }}</div>
            <div class="name name-hidden-product">{{ $static('catalog.t7', 'Приховати товар') }}</div>
            <div class="name name-actions">{{ $static('catalog.t8', 'Виконання дії') }}</div>
          </div>

          <template v-for="(item, index) in items" :key="item.id">
            <!--product card preview-->
            <CatalogProductPreview :item="item" :islist="isList"
                                   @open="event => openEditor(item, event)"
                                   @remove="event => removeItem(item)"
                                   @onCopy="onCopy"/>
            <!--end product card preview-->
          </template>
        </div>

        <div class="pagination-panel" v-if="pages.length > 1">
          <nav>
            <router-link :to="{ name: 'Catalog', params: { page: Math.max(pageIndex-1,1)} }" class="previous extreme"
                         :class="{'disabled': pageIndex<2}">
              <span class="icons icon-left"></span>
            </router-link>

            <ul class="pagination pagination-list">
              <li v-for="(page,index) in pages" :key="index" :class="{ 'active': pageIndex === page}">
                <!--                <a href="javascript:void(0)">{{page}}</a>-->
                <router-link :to="{ name: 'Catalog', params: { page: page} }">{{ page }}</router-link>
              </li>
            </ul>

            <router-link :to="{ name: 'Catalog', params: { page: Math.min(pageIndex+1, pageAmount)} }"
                         class="end extreme"
                         :class="{'disabled': pageIndex > pageAmount-1}">
              <span class="icons icon-right"></span>
            </router-link>
          </nav>
        </div>
      </div>
    </div>

    <Teleport to="body">
      <!-- EDITOR WRAPPER-->
      <div class="overlay-editor item-editor">
        <EditItemAdmin :item="selected" @save="n => onSave(n)" @add="n => onAdd(n)" v-if="selected"/>
      </div>
      <!--END EDITOR WRAPPER-->
    </Teleport>

    <Teleport to="body">
      <div class="filter_sidebar">
        <div class="filter_sidebar_wrapper">
          <div class="panel-top">
            <div class="panel-top-name">{{ $static('catalog.filter', 'Фільтри') }}</div>
            <a href="javascript:void(0);" class="back_trigger">
              <span class="icon icon-cross"></span>
            </a>
          </div>
          <div class="panel-middle">
            <!--all filter parameters-->
            <div class="filter-list">
              <div class="filter-holder">
                <div class="search-panel">
                  <!--search panel-->
                  <div class="search-group">
                    <input type="text" class="input-search form-control custom-input" :placeholder="$static('catalog.phsearch', 'Знайти')"
                           v-model="filter.search">
                    <button class="search-btn">
                      <span class="icon icon-search"></span>
                    </button>
                  </div>
                  <!-- end search panel-->
                </div>
                <div class="filter-panel price-panel">
                  <div class="panel-body ranger-holder">
                    <div class="filter-label">{{ $static('catalog.price', 'Ціна:') }}</div>
                    <div id="slider-price"></div><!--price slider range-->
                  </div>
                </div>
                <!--sizes-->
                <!--                <div class="filter-panel size-panel">-->
                <!--                  <div class="filter-label">Размер:</div>-->
                <!--                  <div class="size-checkbox-group">-->
                <!--                    &lt;!&ndash;size checkbox&ndash;&gt;-->
                <!--                    <div class="option-checkbox">-->
                <!--                      <input id="all_size" type="checkbox" :checked="sizesSelected.length === 0" @change="filter.size = []">-->
                <!--                      <label for="all_size">все</label>-->
                <!--                    </div>-->
                <!--                    &lt;!&ndash;end size checkbox&ndash;&gt;-->
                <!--                    &lt;!&ndash;size checkbox&ndash;&gt;-->
                <!--                    <div class="option-checkbox" v-for="(size, index) in sizes">-->
                <!--                      <input :id="'size' + index" type="checkbox" @change="selectSize(size)" :checked="sizesSelected.indexOf(size) > -1"-->
                <!--                             :value="size" name="size">-->
                <!--                      <label :for="'size' + index">{{size}}</label>-->
                <!--                    </div>-->
                <!--                    &lt;!&ndash;end size checkbox&ndash;&gt;-->
                <!--                  </div>-->
                <!--                </div>-->
                <!--end sizes-->
                <!--colors-->
                <!--                <div class="filter-panel color-panel">-->
                <!--                  <div class="filter-label">Цвет:</div>-->
                <!--                  <div class="color-checkbox-group">-->
                <!--                    &lt;!&ndash;color checkbox&ndash;&gt;-->
                <!--                    <div class="option-checkbox">-->
                <!--                      <input id="all" type="checkbox" :checked="colorsSelected.length === 0" @change="filter.color = []">-->
                <!--                      <label for="all">все</label>-->
                <!--                    </div>-->
                <!--                    &lt;!&ndash;end color checkbox&ndash;&gt;-->
                <!--                    &lt;!&ndash;color checkbox&ndash;&gt;-->
                <!--                    <div class="option-checkbox" v-for="(color, index) in colors">-->
                <!--                      <input :id="'color' + index" type="checkbox" @change="selectColor(color)"-->
                <!--                             :checked="colorsSelected.indexOf(color) > -1" :value="color" name="color">-->
                <!--                      <label :for="'color' + index">{{color}}</label>-->
                <!--                    </div>-->
                <!--                    &lt;!&ndash;end color checkbox&ndash;&gt;-->

                <!--                  </div>-->
                <!--                </div>-->
                <!--end colors-->
                <div class="filter-panel panel-calendar">
                  <div class="filter-label">{{ $static('catalog.data', 'дата додавання:') }}</div>
                  <a href="javascript:void(0)" class="calendar-value"><span class="icon icon-calendar"></span><span
                      class="text">14.03.2022 - 15.05.2022</span><span class="icon icon-right"></span></a>
                </div>
              </div>
            </div>
            <!--end all filter parameters-->
          </div>
          <div class="panel-bottom">
            <button href="javascript:void(0)" class="transparent-btn default-btn  back_trigger" @click="closeFilter">
              <span class="text">{{ $static('catalog.cancel', 'Скасувати') }}</span>
            </button>
            <button href="javascript:void(0)" class=" default-btn btn-accent" @click="acceptFilter">
              <span class="text">{{ $static('catalog.accept', 'Застосувати фільтр') }}</span>
            </button>
          </div>
        </div>
      </div>
    </Teleport>
    <!--    <div v-for="item in items">-->
    <!--      {{item}}-->
    <!--      <router-link :to="{name:'EditItem', params:{id: item.id}}">edit</router-link>-->
    <!--      <button v-if="item.hidden" @click="toggleVisible(item)">hide</button>-->
    <!--      <button @click="toggleVisible(item)" v-else>show</button>-->
    <!--    </div>-->
  </div>
</template>

<script>
  import api from '@/api'
  import CatalogProductPreview from '../components/CatalogProductPreview';
  import EditItemAdmin from '../components/EditItemAdmin';

  const pageSlotsAmount = 5;

  export default {
    name      : 'Catalog',
    components: {CatalogProductPreview, EditItemAdmin},
    props     : ['page'],
    data() {
      return {
        items         : [],
        total         : 0,
        importFile    : undefined,
        categoryFilter: '',
        sortBy        : 'time',
        isList        : true,
        filter        : {
          page       : 1,
          perPage    : 10,
          price      : [],
          category   : '',
          color      : [],
          size       : [],
          add_between: undefined,
          search     : undefined
        },
        sortOptions   : [
          {label: this.$static('sort.op1', 'По умолчанию'), value: 'sort'},
          {label: this.$static('sort.op2', 'Цена (от дешевых к дорогим)'), value: '-p'},
          {label: this.$static('sort.op3', 'Цена (от дорогих к дешевым)'), value: '+p'},
          {label: this.$static('sort.op4', 'Популярные'), value: 'priority'},
          {label: this.$static('sort.op5', 'Новинки'), value: 'time'}
        ],
        // options: [],
        selected      : undefined
      }
    },
    computed  : {
      options() {
        return this.$store.getters.options
      },
      categories() {
        return this.options.find(x => x.option_id === 'category')
      },

      categoriesList() {
        return this.categories ?
          [
            {label: this.$static('srch.all', 'Усі'), code: ''}, ...this.categories.list.map(i => {
            return {label: i.name, code: i.id}
          })
          ] :
          [{label: this.$static('srch.all', 'Усі'), code: ''}]
      },

      colorsSelected() {
        return this.filter.color ? this.filter.color : []
      },
      sizesSelected() {
        return this.filter.size ? this.filter.size : []
      },
      pageCount() {
        return Math.ceil(this.total / this.filter.perPage)
      },
      pages() {
        if (this.pageAmount < pageSlotsAmount) return [...Array(this.pageAmount).keys()].map(x => x + 1);

        let min = Math.max(this.pageIndex - (pageSlotsAmount - 1) / 2, 1);
        if (this.pageIndex + 1 >= this.pageAmount) {
          min = this.pageAmount - 4;
        }
        let result                  = [...Array(pageSlotsAmount).keys()].map(x => x + min);
        result[0]                   = 1;
        result[pageSlotsAmount - 1] = this.pageAmount;

        return result;
      },
      pageAmount() {
        return Math.ceil(this.total / this.filter.perPage);
      },
      pageIndex() {
        return (this.page && Number.isInteger(+this.page)) ? +this.page : 1;
      }
    },
    watch     : {
      categoryFilter(value) {
        this.filter.category = value;
        this.$router.push({name: 'Catalog', params: {page: 1}});
        this.getItems()
      },
      sortBy() {
        this.getItems()
      },
      isList() {
        this.getItems()
      },
      page(val) {
        this.filter.page = val;
        this.getItems()
      }
    },
    methods   : {
      getItems() {
        api.post('/api/item/filter', {filter: this.filter, sortBy: this.sortBy}).then(response => response.data).then(
          data => {
            this.items       = data.result.map(x => {
              if (!x.advanced){
                x.advanced = {}
              }
              return x
            });
            this.filter.page = data.page;
            this.total       = data.total;
          })
      },
      getItemList() {
        api.get('/api/item/list').then(response => response.data).then(
          data => {
            if (data.result) {
              this.$store.commit('setItemList', data.result)
            }
            // this.items       = data.result;
            // this.filter.page = data.page;
            // this.total       = data.total;
          })
      },
      openEditor(item, event) {
        this.selected = Object.assign({}, item);
        // window.$(event.target).toggleClass('open');
        window.$('.filter_sidebar').removeClass('active');
        window.$('body').addClass('is-hidden');

        window.$('.back-blur').toggleClass('active');
        window.$('.overlay-editor.item-editor').toggleClass('active');
      },
      openFilter(item, event) {
        // window.$(event.target).toggleClass('open');
        window.$('.back-blur').addClass('active');
        window.$('.overlay-editor').removeClass('active');

        window.$('.filter_sidebar').addClass('active');
        window.$('body').addClass('is-hidden');
      },
      selectColor(value) {
        try {
          if (this.filter.color.indexOf(value) === -1) {
            this.filter.color.push(value)
          }
        } catch (e) {
          this.filter = Object.assign({}, this.filter, {color: [value]})
        }
      },
      selectSize(value) {
        try {
          if (this.filter.size.indexOf(value) === -1) {
            this.filter.size.push(value)
          }
        } catch (e) {
          this.filter = Object.assign({}, this.filter, {size: [value]})
        }
      },
      closeFilter(item, event) {
        window.$('body').removeClass('is-hidden');
        window.$('body > .active').removeClass('active');
      },
      acceptFilter(event) {
        this.closeFilter();
        this.$router.push({name: 'Catalog', params: {page: 1}});
      },
      addNew() {
        if (!this.selected || (this.selected && this.selected.id)) {
          this.selected = {hidden: true, stock: true, priority: true, advanced: {hot: true}};
        }
        // window.$(event.target).toggleClass('open');
        window.$('.filter_sidebar').removeClass('active');
        window.$('body').addClass('is-hidden');

        window.$('.back-blur').toggleClass('active');
        window.$('.overlay-editor.item-editor').toggleClass('active');
      },
      removeItem(item, event) {
        window.$('#confirm-modal').modal('show');
        window.onModalConfirm = () => {
          api.delete(`/api/item/${item.id}`);
          let idx = this.items.findIndex(i => i.id === item.id);
          if (idx > -1) {
            this.items[idx].deleted = true
          }
          let check = this.items.find(x => x.deleted === undefined);
          if (!check) {
            this.getItems();
          }
        }

      },
      onCopy() {
        this.getItems()
      },
      onSave(item) {
        let idx         = this.items.findIndex(i => i.id === item.id);
        this.items[idx] = item;
      },
      onAdd(item) {
        this.items.unshift(item);
        this.selected = {hidden: true, stock: true, priority: true, advanced: {hot: true}};
      },
      changePriceFilter(value) {
        this.filter = Object.assign(this.filter, {price: value})
      }

    },
    mounted() {
      window.$('.select-custom').selectpicker();
      this.getItems();
      this.getItemList();

      var slider = document.getElementById('slider-price');

      noUiSlider.create(slider, {
        start   : [0, 2500],
        connect : true,
        tooltips: true,
        format  : wNumb({
                          decimals: 0
                        }),
        range   : {
          'min': 0,
          'max': 5000
        }
      });
      slider.noUiSlider.on('change', this.changePriceFilter);

      api.get('/api/options', {filter: this.filter, sortBy: this.sortBy})
        .then(response => response.data)
        .then(data => {
          this.$store.commit('setOptions', data);
        })
    }
  }
</script>

